import { render, staticRenderFns } from "./AddWorkerDialog.vue?vue&type=template&id=6821baa7&"
import script from "./AddWorkerDialog.vue?vue&type=script&lang=js&"
export * from "./AddWorkerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports